import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { getQueryParams } from '../routing/getQueryParams';

/**
 * Custom hook to determine if web branding style overrides should be used.
 * Must be called within a component under `Application` since it utilizes useTheme from foundations-theming.
 */
export const useWebTeamBranding = () => {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const queryParams = getQueryParams();
  const isFromDotComPricingPage = 'hubs_signup-url' in queryParams && (queryParams['hubs_signup-url'].includes('/pricing') || queryParams['hubs_signup-url'].includes('/public-pricing'));
  const useBranding = isTrellis && isFromDotComPricingPage;
  return useBranding;
};